import React from "react";
import ReactDOM from "react-dom";
import Modal from ".";
import { isPromise } from "@/helpers/isPromise";
import { ReactRender } from "@/components/ReactRender";

function modalConfirm({ content, ...options }) {
  const container = document.createElement("div");
  document.body.appendChild(container);

  const unMount = () => {
    ReactDOM.unmountComponentAtNode(container);
    try {
      container.parentElement?.removeChild(container);
    } catch (e) {
      console.warn(e);
    }
  };

  const handleConfirm = () => {
    const req = options.onConfirm?.();
    if (isPromise(req)) {
      req.then(() => {
        unMount();
      });
    } else {
      unMount();
    }
    return req;
  };

  const handleClose = () => {
    unMount();
    return options.onClose?.();
  };

  ReactRender(
    <Modal
      closeable
      open
      {...options}
      onConfirm={handleConfirm}
      onClose={handleClose}
      onCancel={options.onCancel}
    >
      {content}
    </Modal>,
    container
  );
}

export default modalConfirm;
